import { useMutation } from '@apollo/client';
import PriceBadge from 'components/Others/PriceBadge';
import { wcApiDataService } from 'functions/wcApi';
import useUpdateEffect from 'hooks/useUpdateEffect';
import parse from 'html-react-parser';
import { GetStaticPaths, GetStaticProps } from 'next';
import Head from 'next/head';
import Image from "next/legacy/image";
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  convertPriceTextToNumber,
  formatVisiblePrice,
  getSeoMetaTags
} from 'utils/common.utils';
import { BackgroundColor, generateSparePartImage } from 'utils/image.utils';
import { v4 as uuidv4 } from 'uuid';
import Breadcrumb from 'components/Breadcrumb/Breadcrumb';
import Button from 'components/Button/Button';
import Zoom from 'components/Icons/Zoom';
import ProdSliderModal from 'components/ProdSlider/ProdSliderModal';
import Spinner from 'components/Spinner/Spinner';
import { getArmProductId } from 'constants/woocommerceParentCateoryIds';

import { getLocalCurrency } from 'functions/currency';
import { handleregionapollo } from 'functions/handleregionapollo';
import { slugToString, stringToSlug } from 'functions/slug';
import {
  CREATE_CART,
  UPDATE_QUANTITY_CART
} from 'gqlStrings/mutations/addToCart';
import { GET_PRODUCT_BY_ID } from 'gqlStrings/queries/getProduct';
import * as ga from 'lib/ga';
import { addDataLayer } from 'lib/ga';
import {
  setLoading,
  updateShoppingCartWithRequest
} from 'redux/features/bag/bagSlice';
import { RootState } from 'redux/store';
import ProductSpecificIcon from 'components/Others/ProductSpecificIcon';
import { InfoIcon } from 'components/Icons/Info';
import { getUniqueSpareParts } from 'functions/handleSparePart';
import UITooltip from 'components/Others/UITooltip';
import Checkmark from 'components/Icons/Checkmark';
import { FrameSizeEnum } from 'constants/productDetailConsts';
import UIAccordion from 'components/Others/UIAccordion';
import UITabs, { UITab } from 'components/Others/UITabs';
import dynamic from 'next/dynamic';
import useDeviceType from 'hooks/useDeviceType';
import { ProductDetailProps, ProductDetailType, SeoMetaTags } from 'constants/dataTypes';
import { addToCart } from 'redux/features/cart/cartSlice';
import AfterPayInfo from 'components/Others/AfterPayInfo';
import ZipPayInfo from 'components/Others/ZipPayInfo';
import { getSession } from 'functions/session';
import GlobalSeoMetaTags from 'components/GlobalSeoMetaTags/GlobalSeoMetaTags';
import { PrideDiscountBanner } from 'components/ProductDetail/PrideDiscountBanner';

const CustomizeContent = dynamic<ProductDetailProps>(() => import('components/ProductDetail/ProductDetail').then((component) => component.default.CustomizeContent))



export default function SpareParts({
  product,
  productDetailMap,
  seoMetaTags
}: {
  product: any;
  productDetailMap: ProductDetailType[];
  seoMetaTags: SeoMetaTags;
}) {
  const router = useRouter();
  const uuidV4 = uuidv4();


  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [isImported, setIsImported] = useState(false);
  const [mutateCreateCart] = useMutation(CREATE_CART, {
    context: { clientName: 'laravel' }
  });/*
  const selectedRegion = useSelector(
    (state: RootState) => state.regionEvent.selectedRegion
  );*/



  const productDetail = useMemo(() => {
    if (productDetailMap != null) {
      const productDetailInfo = productDetailMap!.filter((productDetail) => {
        return productDetail.slug === `details`
      });
      if (productDetailInfo.length > 0) {
        return { description: productDetailInfo[0].description, title: productDetailInfo[0].sectionTitle }
      }
      return null;
    }
    return null;
  }, [productDetailMap]);


  useEffect(() => {
    if (process.browser && !getSession()) {
      mutateCreateCart({
        variables: {
          input: {
            isEmpty: true
          }
        }
      });
    }
  }, [mutateCreateCart]);

  const [color, setColor] = useState(
    `${router.query.product}`.replace('arms-', '')
  );
  const [sizeState, setSize] = useState();




  const checkVariation = (size: string, color: string) => {
    var check = false;
    product.variations.nodes.filter((node: any) => {
      if (
        node.attributes.nodes[0].value.toLowerCase().split(' ').join('-') ===
        color &&
        node.attributes.nodes[1].value === size
      ) {
        check = true;
      }
    });
    return check;
  };

  useEffect(() => {
    ga.addDataLayer({
      event: 'ImpCompleted',
      ecommerce: {
        detail: {
          actionField: { list: 'Shop' },
          products: [
            {
              name: 'Arms - ' + slugToString(color),
              price: stockPrice,
              category: 'Arms',
              variant: slugToString(color)
            }
          ]
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);

  const handleVariation = (clr: string, sz: string) => {
    const filteredVariation =
      clr &&
      sz &&
      router.query &&
      router.query.product &&
      product.variations.nodes.filter((node: any) => {
        if (
          node.attributes.nodes[0].value.toLowerCase().split(' ').join('-') ===
          clr &&
          node.attributes.nodes[1].value === sz
        ) {
          return node;
        }
      });
    if (filteredVariation) return filteredVariation[0];
  };
  const [prod, setProd] = useState(
    handleVariation(color, sizeState || 'Medium')
  );

  const productName = useMemo(() => {
    return prod && prod ? prod.name.split(',')[0] : 'Arms - ' + slugToString(color);
  }, [prod, color]);

  const productDescription = `${productName} are on this page with advantageous price and Dresden Vision assurance. Shop ${productName} online.`;

  useUpdateEffect(() => {
    setProd(handleVariation(color, sizeState || 'Medium'));
  }, [router.locale]);

  const visiblePrice = useMemo(() => {
    return {
      salePrice: convertPriceTextToNumber(prod?.price),
      regularPrice: convertPriceTextToNumber(prod?.regularPrice)
    };
  }, [prod]);

  const [mutationUpdateItemQuatity] = useMutation(UPDATE_QUANTITY_CART, {
    context: { locale: router.locale },
    onCompleted: (getCartData) => {
      dispatch(
        updateShoppingCartWithRequest(
          getCartData.updateQuantityCompositeItemInCart
        )
      );
      dispatch(setLoading(false));
    },
    onError: (error) => {
      console.log(error);
    }
  });

  const data = product && [
    {
      id: 1,
      href: '',
      text: 'Dresden Vision'
    },
    {
      id: 2,
      href: 'shop',
      text: 'Shop'
    },
    {
      id: 3,
      href: 'shop/spare-parts',
      text: 'Spare Parts'
    },
    {
      id: 4,
      href: `shop/spare-parts/${`${router.query.product}`.replace(
        'arms-',
        ''
      )}`,
      text: productName
    }
  ];
  const isLoad = useSelector((state: RootState) => state.bagEvent.loading);
  const bagItems = useSelector((state: RootState) => state.bagEvent.bag);
  const deviceType = useDeviceType();

  const stockPrice = useMemo(() => {
    const sizes: string[] = product?.allPaSize?.nodes?.map?.(
      (pSize: any) => pSize.name
    );
    const productSizeHasStock = sizes.find((pSize) =>
      handleVariation(color, pSize)
    );
    if (!productSizeHasStock) return 0;

    const stockProduct = handleVariation(color, productSizeHasStock);
    return convertPriceTextToNumber(stockProduct.price);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color, product.allPaSize.nodes]);

  if (router.isFallback) {
    return (
      <div className="flex h-[70vh] items-center justify-center">
        Loading...
      </div>
    );
  }
  const nsbp = String.fromCharCode(160);
  const sortedSizes = product && [...product.allPaSize.nodes];

  sortedSizes.sort((a: any, b: any) => {
    const keyA = parseInt(a.description);
    const keyB = parseInt(b.description);
    if (keyA > keyB) return 1;
    if (keyA < keyB) return -1;
    return 0;
  });

  var colorOrdered: any = [];
  getUniqueSpareParts(product.variations.nodes)
    .sort((a: any, b: any) => {
      const keyA = parseInt(a.sortIndex.index);
      const keyB = parseInt(b.sortIndex.index);
      if (keyA > keyB) return 1;
      if (keyA < keyB) return -1;
      return 0;
    })
    .map((variation: any) => {
      colorOrdered.push(
        product.allPaColor.nodes.filter(
          (color: any) =>
            color.name ===
            variation.attributes.nodes.filter(
              (val: any) => val.name === 'pa_color'
            )[0].value
        )[0]
      );
    });
  //console.log('colorOrdered', colorOrdered);
  const getSeoImage = () => {
    return generateSparePartImage(color, BackgroundColor.White);
  };

  return (
    <div className="relative w-full">
      <Head>


        <title>{`${productName} | Dresden Vision`}</title>
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content="Dresden" />
        <meta property="article:modified_time" content="2023-01-23T08:31:17+00:00" />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content="515" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:label1" content="Availability" />
        <meta name="twitter:data1" content="In stock" />
        <meta property="og:availability" content="instock" />
        <meta property="product:availability" content="instock" />
        <meta property="product:condition" content="new" />

        <meta
          name="twitter:title"
          content={productName}
        />
        <meta
          name="og:title"
          content={productName}
        />
        <meta
          name="description"
          content={productDescription}
        />
        <meta
          property="og:description"
          content={productDescription}
        />
        <meta
          name="twitter:description"
          content={productDescription}
        />
        <meta property="og:image" content={`${getSeoImage()}`} />
        <meta property="twitter:image" content={`${getSeoImage()}`} />

        <title>
          {productName} | Dresden Vision
        </title>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org/',
              '@type': 'Product',
              name: `${productName} `,
              image: [getSeoImage()],
              description: productDescription,
              brand: {
                '@type': 'Brand',
                name: 'DRESDEN VISION'
              },

              offers: {
                '@type': 'Offer',
                url:
                  `${process.env.NEXT_PUBLIC_SITE_URL}` +
                  `${router.locale}` +
                  `${router.asPath}`,
                priceCurrency:
                  router.locale === 'nz'
                    ? 'NZD'
                    : router.locale === 'ca'
                      ? 'CAD'
                      : 'AUD',
                price: stockPrice,
                itemCondition: 'https://schema.org/UsedCondition',
                availability: 'https://schema.org/InStock'
              }
            })
          }}
        />
      </Head>
      {/* <div className="pb-12"> */}
      <div className="mx-auto max-w-[1224px] px-4 pt-6">
        <Breadcrumb data={data} />

        <div className="mt-4 grid grid-cols-2 gap-x-10 xlx:grid-cols-1">
          <div className="z-[22] w-full bg-white">
            <div className="relative flex h-[420px] w-full items-center justify-center rounded border-2 border-brand-grey125 bg-[#f6f8fa] xlx:mx-auto xsmx:h-[280px] xsmx:w-full">
              <ProductSpecificIcon productTitle={color} />
              <div>
                <div className="relative  mx-auto h-[400px] w-[380px] xsmx:h-[275px] xsmx:w-[275px]">
                  <Image
                    quality={50}
                    priority
                    objectFit="cover"
                    layout="fill"
                    alt={
                      prod
                        ? prod.name.split(',')[0]
                        : 'Arms - ' + slugToString(color)
                    }
                    src={generateSparePartImage(color)}
                  />
                </div>
              </div>
              <button
                onClick={() => {
                  setIsImported(true);
                  setModalOpen(true);
                }}
                className="absolute top-4 right-4 flex items-center justify-center">
                <Zoom />
              </button>
            </div>
          </div>
          <div>
            <h1 className="mb-4 font-sans text-3xl font-bold text-black xlx:mt-4 smx:text-2xl">
              {prod
                ? prod.name.split(',')[0]
                : 'Arms - ' + slugToString(color)}
            </h1>
            {prod && (
              <h5 className="text-md mb-4 font-sans font-normal text-black">
                <PriceBadge
                  key={router.locale}
                  price={visiblePrice.salePrice}
                  regularPrice={visiblePrice.regularPrice}
                />
              </h5>
            )}
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-4">
                <div className="font-sans text-xs font-medium tracking-wider text-black">
                  COLOUR
                </div>
                <div className="hide-scroll flex tsm:flex-wrap overflow-auto w-full gap-x-1.5 gap-y-2">
                  {colorOrdered.map((e: any, i: number) => {
                    if (!e) {
                      return null;
                    }
                    return (
                      <UITooltip key={i} id={`color-tooltip-${i}`} delay="20" place="top" message={e.name} messageWrapperClassName={'text-black'} tooltipWrapperClassName={'!rounded-[4px] border !border-[#E2E2E2] border-solid !bg-white shadow-tooltipSecondary white-tip'}>
                        <div
                          key={i}
                          onClick={() => {
                            setColor(e.slug);
                            setProd(handleVariation(e.slug, sizeState || 'Medium'));
                          }}
                          className={`flex items-center justify-center min-w-[30px] h-[30px] cursor-pointer rounded-full ${color == e.slug
                            ? ''
                            : 'border border-brand-grey200 p-[3px]'
                            }`}>
                          {color == e.slug ?
                            <div
                              className={`w-full h-full rounded-full flex justify-center items-center`}
                              style={{ background: `#${e.description}` }}>
                              <Checkmark height={27} width={15} fill={e.name === "White" ? '#000' : '#FFF'} />
                            </div>
                            :
                            <div
                              className={`w-[16px] h-[16px] rounded-full`}
                              style={{ background: `#${e.description}` }}>
                            </div>
                          }
                        </div>
                      </UITooltip>
                    )
                  }
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div className="font-sans text-xs font-medium tracking-wider text-black">
                  SIZE
                </div>
                <div className="flex gap-4">
                  <div className="flex justify-between gap-2">
                    {sortedSizes.map((size: any, i: number) => {
                      return checkVariation(size.name, color) ? (
                        <div
                          key={i}
                          onClick={() => {
                            setSize(size.name);
                            setProd(handleVariation(color, size.name));
                          }}
                          className={`cursor-pointer flex items-center justify-center bg-white border rounded-md w-[54px] h-[46px] p-1 xsmx:h-[53px] ${sizeState == size.name
                            ? 'border-black'
                            : 'border-[#CACACA] hover:border-[#AEADAD]'
                            } duration-300 transition-colors`}>
                          <span className="font-sans font-medium text-sm text-center xsmx:text-xs">
                            {size.name == FrameSizeEnum.EXTRA_SMALL ? "XS" : null}
                            {size.name == FrameSizeEnum.SMALL ? "S" : null}
                            {size.name == FrameSizeEnum.MEDIUM ? "M" : null}
                            {size.name == FrameSizeEnum.LARGE ? "L" : null}
                          </span>
                        </div>
                      ) : (
                        <div
                          key={i}
                          onClick={() => {
                            setSize(size.name);
                            setProd(handleVariation(color, size.name));
                          }}
                          style={{ color: '#dedede' }}
                          className={`disable-size cursor-pointer flex items-center justify-center bg-white border rounded-md w-[54px] h-[46px] p-1 xsmx:h-[53px] ${sizeState == size.name
                            ? 'border-black'
                            : 'border-[#CACACA] hover:border-[#AEADAD]'
                            } transition-colors duration-300`}>
                          <span className="font-sans font-medium text-sm text-center xsmx:text-xs">
                            {size.name == FrameSizeEnum.EXTRA_SMALL ? "XS" : null}
                            {size.name == FrameSizeEnum.SMALL ? "S" : null}
                            {size.name == FrameSizeEnum.MEDIUM ? "M" : null}
                            {size.name == FrameSizeEnum.LARGE ? "L" : null}
                          </span>
                          <div className="hr"></div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {!prod && sizeState && (
              <div className="flex max-w-[308px] mt-[24px] bg-[#fef4cb] items-center gap-[8px] px-[16px] py-[17px]">
                <InfoIcon />
                <p className="text-[14px] leading-[15px] text-[#616161]">
                  This product is not available right now
                </p>
              </div>
            )}

            {prod && (
              <>
                <Button
                  disabled={
                    process.browser && !getSession()
                      ? true
                      : isLoad || !sizeState
                        ? true
                        : false
                  }
                  onClick={() => {
                    const session = getSession();
                    if (session) {
                      dispatch(setLoading(true));
                      dispatch(addToCart({
                        type: 'simple',
                        variables: {
                          queueId: uuidV4,
                          input: {
                            productId: prod.databaseId,
                            clientMutationId:
                              getSession(),
                            quantity: 1
                          }
                        }
                      }));
                      addDataLayer({
                        event: 'addToCart',
                        ecommerce: {
                          currencyCode: getLocalCurrency(router.locale),
                          add: {
                            products: [
                              {
                                name: prod
                                  ? prod.name.split(',')[0]
                                  : 'Arms - ' + slugToString(color),
                                price: Number(
                                  (parse as any)(prod?.price).split(nsbp)[1]
                                ),
                                variant: 'Arms - ' + slugToString(color),
                                category: 'Spare Parts',
                                quantity: 1
                              }
                            ]
                          }
                        }
                      });
                    }
                  }}
                  className="my-auto mt-8 w-full justify-center bg-brand-black50 !px-6 text-center mdx:sticky mdx:bottom-3"
                  textClass="font-medium text-white text-sm">
                  <span className="flex items-center">
                    {isLoad && (
                      <span className="mr-2 mt-[1px]">
                        <Spinner fill="white" />
                      </span>
                    )}
                    <span>
                      Add to cart {' '}
                      {formatVisiblePrice(
                        visiblePrice.salePrice,
                        bagItems.currency
                      )}
                    </span>
                  </span>
                </Button>
                <AfterPayInfo total={visiblePrice.salePrice} />
                <ZipPayInfo total={visiblePrice.salePrice} />
              </>
            )}
          </div>
        </div>

        <UITabs wrapperClassName='mt-[50px]'>
          <UITab wrapperClassName="h-116px" title="Details">
            <div className="flex w-full">
              <p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
                {productDetail?.description}
              </p>
            </div>
          </UITab>
          <UITab wrapperClassName={'h-[349]'} title={router.locale === "ca" ? "Customize" : "Customise"}>
            <CustomizeContent deviceType={deviceType} locale={router.locale} />
          </UITab>
        </UITabs>

        <div className="lg:hidden block">
          <UIAccordion title="Details" defaultOpen={true}>
            <div className="flex flex-col">
              <p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
                {productDetail?.description}
              </p>
            </div>
          </UIAccordion>
          <UIAccordion title={router.locale === "ca" ? "Customize" : "Customise"}>
            <CustomizeContent deviceType={deviceType} />
          </UIAccordion>
        </div>

      </div>

      {/* </div> */}
      {isImported && prod.image.mediaItemUrl && (
        <ProdSliderModal
          setModalOpen={setModalOpen}
          images={[(getSeoImage())]}
          setIsImported={setIsImported}
          alt={prod.name}
          modalOpen={modalOpen}
        />
      )}

      <GlobalSeoMetaTags seoMetaTags={seoMetaTags} />
    </div>
  );
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths: any = [];


  if (process.env.NEXT_PUBLIC_ENV !== 'production') {
    return {
      paths: [],
      fallback: 'blocking',
    }
  }

  var sparePartsCategory: any = await wcApiDataService('paths/spare-parts', '', '');
  if (!sparePartsCategory) {
    return {
      paths,
      fallback: 'blocking'
    };
  }
  for (const [country, data] of Object.entries(sparePartsCategory) as any) {


    for (const [, color_list] of Object.entries(data.items) as any) {

      color_list.map((color_id: any) => {
        paths.push({
          params: {
            product: `arms-${data.colors[color_id]}`
          },
          locale: country
        });
      })

    }

  }

  return {
    paths,
    fallback: 'blocking'
  };
};

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  let res;
  if (params?.product) {
    res = await handleregionapollo(locale).query({
      query: GET_PRODUCT_BY_ID,
      variables: {
        id: getArmProductId(locale),
        idType: 'DATABASE_ID'
      },
      context: { region: locale }
    });
  }
  if (!res) {
    return {
      notFound: true
    };
  }
  var slugName: any;
  if (params && params.product && typeof params.product === 'string') {
    slugName = params.product.replace('arms-', '');
  }
  if (
    !res?.data.product.allPaColor.nodes.filter(
      (color: any) => color.slug === slugName
    )[0]
  ) {
    return {
      notFound: true
    };
  }


  //Retrieve product descriptions from Notion DB
  const bodyContent = JSON.stringify({
    property: "Category",
    select: {
      equals: 'spare-parts'
    }
  });

  //fetch post request to process.env.NEXT_PUBLIC_LARAVEL_URL + '/api/db/' + process.env.NOTION_PRODUCT_DETAIL_DB
  const resProductDetailsNotion = await fetch(process.env.NEXT_PUBLIC_LARAVEL_URL + '/api/db/' + process.env.NOTION_PRODUCT_DETAIL_DB, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: bodyContent
  });
  if (resProductDetailsNotion.status !== 200) {
    return {
      notFound: true
    };
  }
  const productDetails = await resProductDetailsNotion.json();
  const productDetailMap: any[] = [];
  if (productDetails && productDetails.length > 0) {
    productDetails.map((detail: any) => {
      //const sectionSlug = detail.colour;
      if (detail.region.length > 0 && !detail.region.includes(locale)) {
        console.log('not found');
        return;
      }
      let sectionSlug = stringToSlug(detail.section);
      if (detail.colour) {
        sectionSlug += '-' + detail.colour;
      }
      const content = { 'slug': sectionSlug, 'sectionTitle': detail.sectionTitle, 'description': detail.description };

      productDetailMap.push(content);
    });
  }

  const seoMetaTags = await getSeoMetaTags('/shop/spare-parts/' + params?.product, locale);

  return {
    props: {
      product: res.data.product,
      productDetailMap: productDetailMap,
      seoMetaTags
    }
  };
};
